var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/joy";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
import "./settings";
import "./list";
import { useContext, useEffect, useRef, useState } from "react";
import { FormSettingsContext, getColorStyle, getLayoutStyle, getStyleSpacing, scrollToEl, } from "../../utils";
import { FormComponentButtons } from "../../formComponentButtons";
/**
 * Header edit component
 *
 * @param param0
 */
export function Header(_a) {
    var _b;
    var isSelected = _a.isSelected, layoutParent = _a.layoutParent, isStudioField = _a.isStudioField, meta = _a.meta;
    var _c = useContext(FormSettingsContext), settings = _c.settings, editedSettings = _c.editedSettings;
    var refs = useRef(null);
    var content = meta.settings.content;
    // Css pour le studio
    var borderStyle = isStudioField
        ? "border border-gray-500 border-dashed hover:border-red-500"
        : "";
    // clique sur le composant
    var onClickComponent = function (e) {
        e.stopPropagation();
        editedSettings(__assign(__assign({}, settings), { target: meta.id, type: meta.type, component: meta, selected: meta.id, parentId: layoutParent, currentComponent: meta }));
        scrollToEl(refs && (refs === null || refs === void 0 ? void 0 : refs.current));
    };
    // si composant séléctionné
    useEffect(function () {
        isStudioField &&
            settings.selected === meta.id &&
            editedSettings(__assign(__assign({}, settings), { target: meta.id, type: meta.type, component: meta, selected: meta.id, parentId: layoutParent, currentComponent: meta }));
    }, [isStudioField && settings.selected]);
    // Styles
    var _d = useState({}), styles = _d[0], setStyles = _d[1];
    useEffect(function () {
        var _a, _b;
        var spacingStyle = (meta.settings && __assign(__assign({}, getStyleSpacing(((_a = meta.settings) === null || _a === void 0 ? void 0 : _a.styles) || {})), getColorStyle(((_b = meta.settings) === null || _b === void 0 ? void 0 : _b.styles) || {}))) ||
            "";
        setStyles(__assign({}, spacingStyle));
    }, [(_b = meta === null || meta === void 0 ? void 0 : meta.settings) === null || _b === void 0 ? void 0 : _b.styles]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ style: styles, ref: function (el) {
                    if (el)
                        refs.current = el;
                }, id: meta.id }, { children: _jsx("div", __assign({ className: "flex flex-col w-full", onClick: function (v) {
                        isStudioField && onClickComponent(v);
                    }, style: getLayoutStyle(isSelected === meta.id) }, { children: _jsx("div", __assign({ className: "relative" }, { children: _jsx("div", __assign({ className: "flex flex-row flex-auto ".concat(borderStyle) }, { children: _jsx(Typography, __assign({ level: meta.settings.type, sx: { color: styles.color } }, { children: content })) })) })) })) })), isStudioField && (_jsx(_Fragment, { children: _jsx(FormComponentButtons, { parentId: layoutParent, meta: meta || [], isLayout: false, isSelected: isSelected === meta.id }) }))] }));
}
layoutComponentsDictionary.registerLayoutComponent("header", Header);
